import ICONS from "../icons";
import { differentiators } from "../../data/siteContent";

export const Differentiators = ({ scrollToSection }) => (
  <section className="section muted diff" id="why" data-testid="differentiators-section">
    <div className="section-heading" data-testid="differentiators-heading">
      <h2 data-testid="differentiators-title">Why teams and individuals choose Vartalab</h2>
      <p data-testid="differentiators-subtitle">
        We are not a generic social media agency. Every engagement is built
        around the specific world you operate in.
      </p>
    </div>
    <div className="diff-grid" data-testid="differentiators-grid">
      {differentiators.map((item, index) => {
        const DiffIcon = ICONS[item.icon];
        return (
          <div
            className="diff-card"
            key={item.title}
            data-testid={`differentiator-card-${index}`}
          >
            <span className="diff-icon" aria-hidden="true">
              <DiffIcon />
            </span>
            <h3 data-testid={`differentiator-card-${index}-title`}>{item.title}</h3>
            <p data-testid={`differentiator-card-${index}-description`}>
              {item.description}
            </p>
          </div>
        );
      })}
      <div className="diff-card highlight" data-testid="differentiator-highlight">
        <span className="diff-icon" aria-hidden="true">
          <ICONS.Compass />
        </span>
        <h3 data-testid="differentiator-highlight-title">
          Not sure which pillar fits you?
        </h3>
        <p data-testid="differentiator-highlight-text">
          Book a free call and we will help you find the right starting point
          together.
        </p>
        <button
          className="ghost-button small"
          onClick={() => scrollToSection("contact")}
          data-testid="differentiator-highlight-cta"
        >
          Talk to Vartalab
        </button>
      </div>
    </div>
  </section>
);
